<script setup lang="ts">
/** Field with a native select: label above, 32px control, one hint under. Same shell as Field. */
defineProps<{ label: string; modelValue: string; options: { value: string; label: string }[]; hint?: string; mono?: boolean }>()
const emit = defineEmits<{ 'update:modelValue': [v: string] }>()
const onChange = (event: Event) => emit('update:modelValue', (event.target as HTMLSelectElement).value)
</script>

<template>
  <label class="flex flex-col gap-1.5">
    <span class="text-xs text-muted-foreground">{{ label }}</span>
    <span class="relative">
      <select
:value="modelValue" :class="mono ? 'num' : ''"
        class="h-8 w-full appearance-none rounded-[var(--radius-control)] border border-border bg-muted/40 px-2.5 pr-7 text-[length:var(--type-control)] text-foreground focus:border-primary/60 focus:outline-none"
        @change="onChange">
        <option v-for="o in options" :key="o.value" :value="o.value">{{ o.label }}</option>
      </select>
      <svg class="pointer-events-none absolute right-2 top-1/2 size-3 -translate-y-1/2 text-muted-foreground" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6" /></svg>
    </span>
    <span v-if="hint" class="num text-[length:var(--type-fine)] text-muted-foreground">{{ hint }}</span>
  </label>
</template>
